import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type { GroupMember } from './use-load-group-members';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export type AddGroupMemberVariables = { userId: number; role: GroupMember['role'] };

export async function addGroupMemberFn(
  axiosInstance: Promise<AxiosInstance>,
  variables: AddGroupMemberVariables,
) {
  const instance = await axiosInstance;
  return instance.post('/group/members', variables);
}

export function useAddGroupMember() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, AddGroupMemberVariables>({
    mutationFn: variables => addGroupMemberFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['groupMembers'] });
      client.invalidateQueries({ queryKey: ['groupCandidates'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    AddGroupMemberVariables,
    'addGroupMember'
  >('addGroupMember', mutation);
}
